export enum Orientation {
  HORIZONTAL = 'orientation-horizontal',
  VERTICAL = 'orientation-vertical',
}
